/**
 * Settings Module
 */
import { Notification } from 'vue-notifyjs'

const state = {
  config: {
    theme: {
      light: {
        primary: '#0CA750',
        ggprimary: '#3db14e',
        secondary: '#424242',
        accent: '#0CA750',
        error: '#FF3739',
        info: '#2196F3',
        success: '#0CA750',
        warning: '#FFB70F',
        warning_alert: '#ff9900',
        header: '#002838',
        grey: '#E7E7E7',
        bg_grey: '#F0F0F0',
        bt_grey: '#ececec'
      },
      dark: {
        primary: '#0ca750',
        header: '#12171f',
        accent: '#0CA750',
      },
    },
    routerAnimation: 'fadeIn', // Can be 'slideInUp', 'fadeIn', 'slideInRight', 'bounce', 'lightSpeedIn', 'pulse'
    brand: {
      appLogo: '/static/img/amui/logo.png', // App Logo,
      darkLogo: '/static/img/amui/logo_black.png', // dark logo
      brand: 'GreenGeeks', // Brand Name
      copyrightText: 'GreenGeeks © 2018 All Rights Reserved.', // Copyright Text
    },
    pagination: [25, 50, 100],
    paginationBilling: [10, 25, 50, 100],
    itemsPerPage: 25,
  },
  apiVersion: 0,
  outdatedCacheModal: false,
  navDrawer: null,
}

// getters
const getters = {
  theme: state => state.config.theme,
  routerAnimation: state => state.config.routerAnimation,
  brand: state => state.config.brand,
  pagination: state => state.config.pagination,
  itemsPerPage: state => state.config.itemsPerPage,
  notify: state => state.notify,
  apiVersion: state => state.apiVersion,
  outdatedCacheModal: state => state.outdatedCacheModal,
  navDrawer: state => state.navDrawer,
  paginationBilling: state => state.config.paginationBilling,
}

const mutations = {
  SET_API_VERSION (state, version) {
    state.apiVersion = version
  },
  OPEN_OUTDATED_CACHE_MODAL (state) {
    state.outdatedCacheModal = true
  },
  SET_NAV_DRAWER (state, drawer) {
    state.navDrawer = drawer
  },
}

// actions
const actions = {
  reportSuccess () {
    Notification.notify({
      verticalAlign: 'top',
      horizontalAlign: 'right',
      type: 'success',
      timeout: 5000,
      message: arguments[1].toString()
    })
  },
  reportError () {
    let msg
    if (typeof arguments[1] !== 'object') {
      msg = arguments[1]
    } else {
      msg = arguments[1].message.toString()
    }

    Notification.notify({
      verticalAlign: 'top',
      horizontalAlign: 'right',
      type: 'danger',
      timeout: 10000,
      message: msg
    })
  },
  reportLogout ({ commit }, msg) {
    // console.log(msg)
    Notification.notify({
      verticalAlign: 'top',
      horizontalAlign: 'right',
      type: 'danger',
      timeout: 0,
      message: msg.toString()
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
